import React from 'react';
import useGet from "../../components/hooks/useGet";
import {Pages} from "../../components/layout";
import {Alert, Loading} from "fearless-common-ui";
import BackendForm from "../../components/forms/BackendForm";
import FloatingLabelField from "../../components/forms/FloatingLabelField";
import Header from "../../components/Header";
import {routes} from "../../utils";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {backendEndpoints} from "../../libs/backendEndpoints";
import {useNavigate} from "react-router-dom";

export default function TwoFactorAuthentication() {
    const [hasSuccess, setHasSuccess] = React.useState(false);
    const navigate = useNavigate();
    const { data: svg, error, isLoading } = useGet({
        endpoint: backendEndpoints.twoFactorQrCode,
        dataKey: 'svg',
        withCredentials: true,
        withXSRFToken: true,
    });

    return (
        <Pages.Centred width="xs">
            <h2>Two factor authentication</h2>
            <ol>
                <li>
                    Download and open any authenticator app. (e.g., Microsoft, Google Authenticator).
                </li>
                <li>Scan the QR code.</li>
                <li>Enter the code down below.</li>
            </ol>

            {isLoading && <Loading />}
            {error && <Alert variant="danger">{error}</Alert>}
            <div className="my-5" />

            <Row className="align-items-center">
                <Col sm={4}>
                    {svg && <div dangerouslySetInnerHTML={{
                      // @ts-ignore
                      __html: svg
                    }} />}
                </Col>
                <Col sm={{ offset: 1, span: 7 }}>
                    <Header component="h6" className="ps-4">Please enter the code</Header>
                    <BackendForm
                        showFooter={!hasSuccess}
                        initialValues={{ code: '' }}
                        targetMethod="POST"
                        targetEndpoint="/user/confirmed-two-factor-authentication"
                        onSuccess={() => {
                            setHasSuccess(true);
                            navigate(routes.twoFactorAuthenticationSuccess);
                        }}
                        config={{
                          withCredentials: true,
                          withXSRFToken: true,
                        }}
                    >
                        <FloatingLabelField name="code" label="Code from your authenticator app" disabled={hasSuccess} />
                        {hasSuccess && (
                          <div className="d-flex text-end">
                            Redirecting...
                          </div>
                        )}
                    </BackendForm>
                </Col>
            </Row>

        </Pages.Centred>
    );
}
